<template>
<div class="page" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中">
    <topNav :showWater="showWater"></topNav>
    <AdvLamu :advCode="'owlxo1101'" :isDD="true" :ddCode="'aiegc8103'"></AdvLamu>
    <Header :showWater="showWater"></Header>
    <columnNav :showWater="showWater"></columnNav>
    <div class="pw">

        <div class="lotChangeBox">
            <i class="el-icon-arrow-left" :class="leftArrClass" style="margin-right: 10px;" @click="jumpLot(false)"></i>
            <div class="lotText" @click="openProductBox()">
                {{'LOT '+ tlNum }}
                <i class="el-icon-arrow-down"></i>
            </div>
            <i class="el-icon-arrow-right" :class="rightArrClass" style="margin-left: 10px;" @click="jumpLot(true)"></i>
        </div>
        <AdvImage :advCode="'vuzof1102'" :isDD="true" :ddCode="'chidk8310'"></AdvImage>
        <!-- <div class="flex marTop10">
            <contact :contactData="contactData"></contact>
        </div> -->
    </div>
    <Crumbs :arr="crumbs" :showWater="showWater"></Crumbs>
    <div class="productBanner">
        <div class="pw" style="display: flex;">

            <ProductHeader :proTitle="showTitle" :tlNum="tlNum" :labelList="labelList" :bigPicArray="bigPicArray" :picWidth="PicWidth" :picHeight="PicHeight" :ppinData="detailData" :isLogin="isLogin" :isHd="isHD" :scJSON="scJSON"></ProductHeader>
            <div class="productMsgBox">
                <!-- <div class="artronIcon">

                </div> -->
                <div class="proTitle" v-html="showTitle">

                </div>
                <div class="productFlag">
                    <div class="flag" v-if="labelList"><span v-for="(item,k) in labelList" :key="k">{{item.name}}</span></div>
                </div>
                <img  @click="gotoDownLoad" src="@/assets/imgs/Group73@2x.png" alt="" style="cursor: pointer;width: 100%;    margin-bottom: 26px;"   />
                <div class="proPriceBox">
                    <template v-for="(item,i) in detailObj.extraInfo">
                        <div class="priceMsg" v-if="item.type == 'gujia'" :key="i">
                            <div class="priceLabel">{{item.label}}</div>
                            <div class="priceText"> 
                                <span style="display: inline-block;">{{item.smallText}}</span>
                                {{item.text.indexOf("\n") !== -1 ?item.text.split("\n")[0]:item.text}} 
                               
                                <template v-if="item.otherText!=''">
                                    <br/><span style="margin-top: 20px;display: inline-block;">{{item.otherSmallText}}</span>{{ item.otherText }}
                                </template>
                            </div>
                        </div>
                        
                        <template v-if="detailData.bid_type!=1&detailData.bid_type!=2">

                            <div class="priceMsg" v-if="item.type == 'start_price'" :key="i">
                                <div class="priceLabel">{{item.label}}</div>
                                <div class="priceText"><span style="margin-right: 5px;">{{item.smallText}}</span> {{item.text}} <span class="greenTip">*雅昌拍卖图录提供数据展示</span></div>
                            </div>
                            <div class="priceMsg" v-if="item.type == 'now_price'" :key="i">
                                <div class="priceLabel">{{item.label}}</div>
                                <div class="priceText"> <span style="margin-right: 5px;">{{item.smallText}}</span> {{item.text}} <span class="greenTip">*雅昌拍卖图录提供数据展示</span></div>
                            </div>
                            <div class="priceMsg" v-if="item.type == 'price'" :key="i">
                                <div class="priceLabel">{{item.label}}</div>
                                <div class="priceText">

                                    <template v-if="item.text=='未提供'">
                                        {{item.text}}
                                    </template>
                                    <template v-else>
                                        <template v-if="isLogin&&isMem==1||detailObj.BidSpecialStatus==2">
                                            <template v-if="item.text.indexOf('\n') !== -1">
                                                {{item.text.split("\n")[1].split(" ")[1]}}
                                                <span>{{item.text.split("\n")[1].split(" ")[0]}}</span>
                                            </template>
                                         
                                            {{item.text.indexOf("\n") !== -1 ?item.text.split("\n")[0]:item.text}}

                                        </template>
                                        <template v-else>
                                            ****
                                        </template>

                                       <span>{{item.smallText}}</span>
                                       
                                       <span class="greenTip">*雅昌拍卖图录提供数据展示</span>
                                    </template>

                                </div>
                            </div>
                        </template>
                    </template>
                    <div class="priceMsg" v-if="detailData.bid_type==1||detailData.bid_type==2">
                        <div class="priceLabel" v-if="priceInfo.label">{{priceInfo.label}}</div>
                        <template v-if="isLogin&&isMem==1||detailObj.BidSpecialStatus==2||priceInfo.label=='起拍价'">
                            <template v-if="status == 5">
                                <div class="priceText"><span style="margin-right: 5px;">{{ jingpai.currency }}</span> {{priceInfo.price }}<span class="greenTip">*雅昌拍卖图录提供数据展示</span></div>
                            </template>
                            <template v-else>
                                <template v-if="jingpai.auction_endding_status === 1">
                                    <div class="priceText"> {{ jingpai.auction_endding_writting }}</div>
                                </template>
                                <template v-else-if="jingpai.auction_status === 2">
                                    <div class="priceText"> 流拍</div>
                                </template>
                                <template v-else-if="jingpai.auction_status === 3">
                                    <div class="priceText"> 撤拍</div>
                                </template>
                                <template v-else>
                                    <div class="priceText"><span style="margin-right: 5px;">{{ jingpai.currency }}</span>{{priceInfo.price }}<span></span><span class="greenTip">*雅昌拍卖图录提供数据展示</span></div>
                                </template>
                            </template>
                       

                        </template>
                        <template v-else>
                            <div class="priceText" v-if="detailObj.price"> <span>{{detailObj.price.nonMemberText || '****'}}</span></div>
                        </template>

                    </div>
                    <!-- <template v-for="(item,i) in jingpai.show_lists">
                        <div class="priceMsg" v-if="item.title=='起拍价'" :key="i">
                            <div class="priceLabel">{{item.title}}</div>
                            <div class="priceText"> {{item.content.substring(4)}} <span>{{item.currency}}</span> </div>
                        </div>
                    </template> -->
                </div>
                <div class="proInfo">

                    <template v-for="(item,i) in jingpai.show_lists">
                        <div class="infoRow" :key="i" v-if="item.title=='保证金'&&detailObj.BidShowTradePrice==1">
                            <div class="infoLabel">{{item.title}}</div>
                            <div class="infoText">{{item.content}}

                            </div>
                        </div>
                        <div class="infoRow" :key="i" v-if="item.title=='佣金'&&detailObj.BidShowTradePrice==1">
                            <div class="infoLabel">佣金</div>
                            <div class="infoText">{{item.content}}
                                <template v-if="jingpai.commission_allowance_list.max_commission">
                                    <div class="max-commission">
                                        最高补贴{{ jingpai.commission_allowance_list.max_commission }}
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>
                    <!-- <div class="infoRow" v-if="detailData&&detailData.bid_deposit_text">
                        <div class="infoLabel">保证金</div>
                        <div class="infoText">{{detailData.bid_deposit_text.substring(4)}}</div>
                    </div> -->
                    <!-- <div class="infoRow">
                        <div class="infoLabel">佣金</div>
                        <div class="infoText">13.5%</div>
                    </div> -->
                    <template v-for="(item,i) in pcExtraInfo">
                        <div class="infoRow" :key="i" v-if="item.label=='拍卖时间'">
                            <div class="infoLabel">{{timeStr()}}</div>
                            <div class="infoText">{{timeStrText(item.text)}}</div>
                        </div>
                    </template>

                </div>
                <template v-if="detailData">

                    <div class="liveBtn" v-if="detailData.bid_type==1||detailData.bid_type==2" :style="detailData.bid_status==3?'background: #aaa;':''" @click="gotoAPPFun()">
                        <template v-if="(detailData.bid_type==1||detailData.bid_type==2)&&detailData.bid_status==1">
                            委托出价
                        </template>
                        <template v-if="detailData.bid_type==1&&detailData.bid_status==2">
                            直播中
                        </template>
                        <template v-if="detailData.bid_type==2&&detailData.bid_status==2">
                            立即出价
                        </template>
                        <template v-if="(detailData.bid_type==1||detailData.bid_type==2)&&detailData.bid_status==3">
                            已结拍
                        </template>
                    </div>

                </template>
                <div class="bidListBox" v-if="detailData&&(detailData.bid_type==1||detailData.bid_type==2)&&detailObj.BidShowTradePrice==1&&bidList.length>0">
                    <div class="bidListTitle">
                        <span class="bidTitle">出价记录</span> <span class="bidtotal">共<span style=" font-weight: 600;color: #000000;">{{bidListTotal}}次</span>出价</span><span @click="dialogVisible = true" class="allBidBtn">全部></span>
                    </div>
                    <div class="bidListMsg">
                        <template v-for="(item,i) in bidList">
                            <div class="bidBox" :key="'bidBox'+i">
                                <span class="bidLabelBox" :class="item.bid_status==1||item.bid_status==3?'bidLead':''">

                                    <template v-if="item.bid_status==1">
                                        领先
                                    </template>
                                    <template v-else-if="item.bid_status==3">
                                        成交
                                    </template>
                                    <template v-else>
                                        出局
                                    </template>
                                </span>
                                <span class="bidName">
                                    {{item.username}}
                                </span>
                                <span class="bidName">
                                    <template v-if="isMem==1||detailObj.BidSpecialStatus==2||priceJudge()">
                                        {{item.currency}}
                                        <span style="font-weight: 600;"> {{item.bid_price>0?item.bid_price/100:'未提供'}}</span>
                                       
                                    </template>
                                    <template v-else>
                                        {{item.currency}}
                                        <span style="font-weight: 600;"> {{item.bid_hidden_price}}</span>
                                       
                                    </template>

                                </span>
                                <span class="bidTime">
                                    {{item.bid_time}}
                                </span>
                            </div>

                        </template>

                    </div>

                </div>

            </div>

            <div class="productList" v-if="openProduct">
                <div class="proSearch">
                    <el-input placeholder="搜索lot号" v-model="input2" @keyup.enter.native="gotoSo">
                        <el-button slot="append" icon="el-icon-search" @click="gotoSo"></el-button>
                    </el-input>
                    <a :href="'javascript:;'" class="allBtn" v-if="$route.query.from == 1">全部拍品</a>
                    <a :href="'/special_detail/'+speId+'?from=2'" class="allBtn" v-else-if="$route.query.from == 2">全部拍品</a>
                    <a :href="'/special_detail/'+speId" class="allBtn" v-else target="_blank">全部拍品</a>
                </div>
                <div class="productListBox" ref="productListBox">
                    <div v-if="proList.length" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-immediate="false">
                        <dl class="fix" v-for="(item,i) in proList" :key="i" :class="{
                            'curr':$route.params.id == item.ArtCode
                        }">
                            <dt>
                                <a :href="'javascript:;'" v-if="$route.query.from == 1">
                                    <div class="imgBox">
                                        <el-image style="width: 100%; height: 100%;" :src="item.FileName" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="bigFlag" v-if="item.IsBigPic>0"></div>
                                    </div>
                                    <span class="flag"></span>
                                </a>
                                <a :href="'/paimai-'+item.ArtCode+'?form=2'" v-else-if="$route.query.from == 2">
                                    <div class="imgBox">
                                        <el-image style="width: 100%; height: 100%;" :src="item.FileName" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="bigFlag" v-if="item.IsBigPic>0"></div>
                                    </div>
                                    <span class="flag"></span>
                                </a>
                                <a :href="'/paimai-'+item.ArtCode+'?form=2'" v-else>
                                    <div class="imgBox">
                                        <el-image style="width: 100%; height: 100%;" :src="item.FileName" fit="contain">
                                            <div slot="placeholder" class="image-slot">
                                                加载中<span class="dot">...</span>
                                            </div>
                                            <div slot="error" class="el-image__error">
                                                <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                            </div>
                                        </el-image>
                                        <div class="bigFlag" v-if="item.IsBigPic>0"></div>
                                    </div>
                                    <span class="flag"></span>
                                </a>
                            </dt>
                            <dd>
                                <h4 class="name">
                                    <a :href="'javascript:;'" v-if="$route.query.from == 1">{{ item.WorkName }}</a>
                                    <a :href="'/paimai-'+item.ArtCode+'?form=2'" v-else-if="$route.query.from == 2">{{ item.WorkName }}</a>
                                    <a :href="'/paimai-'+item.ArtCode" v-else>{{ item.WorkName }}</a>
                                </h4>
                                <p>Lot号：{{item.TlNumber}}</p>
                                <p>
                                    {{item.Price.label}}
                                    <i class="sessimg-red">
                                        <template v-if="item.Price.label=='估价'">
                                            {{item.Price.smallText}}&nbsp;{{item.Price.text}}
                                        </template>
                                        <template v-else-if="isLogin&&isMem==1||detailObj.BidSpecialStatus==2||item.Price.text=='未提供'">
                                            {{item.Price.text.substring(0, 3)==item.CurrencyType||item.Price.text=='撤拍'||item.Price.text=='未提供'||item.Price.text=='流拍'?'':item.CurrencyType}}&nbsp;{{item.Price.text}}
                                        </template>
                                        <template v-else>

                                            {{item.CurrencyType}}&nbsp;****

                                        </template>
                                    </i></p>
                                <!-- <p v-if="status == 5">
                                    成交价：
                                    <template v-if="isLogin"><i class="sessimg-red">
                                            <template v-if="item.CurrencyPrice == 0&&isMem==1">

                                                <template v-if="item.Status == 1">撤拍</template>
                                                <template v-else-if="item.Status == 2">流拍</template>
                                                <template v-else>未提供</template>

                                            </template>
                                            <template v-else-if="isMem!=1">
                                                <template v-if="item.Status == 1">{{item.CurrencyType}}&nbsp;****</template>
                                                <template v-else-if="item.Status == 2">{{item.CurrencyType}}&nbsp;****</template>
                                                <template v-else-if="item.Status == 3 ||item.CurrencyPrice==0&&item.Status==0">未提供</template>
                                                <template v-else>{{item.CurrencyType}}&nbsp;{{formatPriceTologin(item.CurrencyPrice)}}</template>
                                            </template>
                                            <template v-else>
                                                <template v-if="item.Status != 3&&item.CurrencyPrice != 0">
                                                    {{item.CurrencyType}}&nbsp;{{formatPrice(item.CurrencyPrice)}}
                                                </template>
                                                <template v-else>
                                                    未提供
                                                </template>

                                            </template>
                                        </i></template>
              
                                    <template v-else>

                                        <a href="javascript:;" @click="gotoLogin">
                                            <template v-if="item.Status == 1 || item.Status == 2">{{item.CurrencyType}}****</template>
                                            <template v-else-if="item.Status != 3&&item.CurrencyPrice!=0">
                                                {{item.CurrencyType}}&nbsp;{{formatPriceTologin(item.CurrencyPrice)}}
                                            </template>
                                            <template v-else>
                                                未提供
                                            </template>

                                        </a></template>
                                </p>
                                <p v-else>估价：<i class="sessimg-red">
                                        <template v-if="item.EvaluationType == 1">无底价</template>
                                        <template v-else-if="item.EvaluationType == 2">咨询价</template>
                                        <template v-else-if="item.EvaluationType == 3">估价待定</template>
                                        <template v-else>
                                            <template v-if="item.OriginalEvaluation == 0 && item.LastEvaluation == 0">--</template>
                                            <template v-else-if="item.OriginalEvaluation == item.LastEvaluation">{{ item.OriginalEvaluation }}</template>
                                            <template v-else>{{item.CurrencyType}} {{ formatPrice(item.OriginalEvaluation) }}-{{
                                                    formatPrice(item.LastEvaluation)
                                                }}</template>
                                        </template></i>
                                </p> -->
                                <!--                                    <p v-else>估价：{{item.CurrencyType}} {{formatMoney(item.OriginalEvaluation)}}<template v-if="item.LastEvaluation > 0">-{{formatMoney(item.LastEvaluation)}}</template></p>-->
                                <p>日期：{{item.Date}}</p>
                            </dd>
                        </dl>
                    </div>
                    <EmptyPage v-else></EmptyPage>
                </div>
            </div>
        </div>
    </div>
    <div class="pw">
        <div class="flex mt30" style="margin-top: 70px;">
            <div class="w880">
                <ProductInfo :extraInfo="extraInfo" :attribute="attr" :qrcodePic="qrcodePic" :status="status" :isLogin="isLogin" :pcExtraInfo="pcExtraInfo" :proTitle="showTitle" :scJSON="scJSON"></ProductInfo>
                <SessionList :colName="companyName+'历史拍卖纪录'" :link="'https://artso.artron.net/auction/search_auction.php?OrganCode='+companyId+'&Status=2'" :isMem="isMem" :status="5" :t="t" :isLogin="isLogin" :organList="organResultList" v-if="organResultList.length > 0"></SessionList>
                <SessionList :colName="companyName+'目前预展作品'" :link="'https://artso.artron.net/auction/search_auction.php?OrganCode='+companyId+'&Status=1'" :organList="organPreList" :t="t" v-if="organPreList.length > 0"></SessionList>
                <Mark :indexList="indexList" v-if="indexList.length > 0"></Mark>
            </div>
            <ProductRight :otherPreList="otherPreList" :newsList="newsList" :sessionList="sessionList" :companyName="companyName" :companyId="companyId" :extraInfo="extraInfo" :speId="speId" :t="t"></ProductRight>
        </div>
    </div>
    <copyright :showWater="showWater"></copyright>
    <watermark v-if="showWater"></watermark>
    <anchorBox></anchorBox>
    <el-dialog title="" width="700px" :visible.sync="dialogVisible" custom-class="AdGroupBox">

        <img @click="jumpLink('https://artexpress.artron.net/download/tulu')" src="@/assets/imgs/gotoApp.png" alt="">
    </el-dialog>
</div>
</template>

<script>
// import '../../assets/js/social-share'
// import '../../assets/js/qrcode'
// import vueCustomScrollbar from 'vue-custom-scrollbar'
import $ from 'jquery'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import anchorBox from "@/components/common/anchorBox";
import copyright from "@/components/common/copyright";
import Header from "@/components/common/header";
import topNav from "@/components/common/topNav";
import columnNav from "@/components/common/columnNav";
import contact from "@/components/common/contact";
import {
    getMemType
} from "@/api/auction";
import Crumbs from "@/components/crumbs";
import SessionList from "@/views/auction/components/product/sessionList";
import ProductInfo from "@/views/auction/components/product/productInfo";
import ProductRight from "@/views/auction/components/product/ProductRight";
import Mark from "@/views/auction/components/product/mark";
import ProductHeader from "@/views/auction/components/product/productHeader";
import EmptyPage from "@/components/common/emptyPage";
import watermark from "@/components/common/watermark";
import {
    getProDetail,
    getProReco,
    getProList,
    getProSession,
    getBidList,
    getAuctionInfo
} from "@/api/product/detail";
import {
    mapActions,
    mapGetters
} from 'vuex';
import AdvLamu from "@/components/advert/advLamu";
import AdvImage from "@/components/advert/advImage";
import {
    sendScData
} from "@/utils/buriedPoint";

export default {
    name: "product_detail",
    data() {
        return {
            bidListTotal: 0,
            bidList: [],
            dialogVisible: false,
            contactData: null,
            isMem: 0,
            showWater: this.$route.query.from ? true : false,
            settings: {
                suppressScrollY: false,
                suppressScrollX: false,
                wheelPropagation: false
            },
            proIdx: NaN,
            id: this.$route.params.id.replace('/', ''),
            input2: '',
            crumbs: [{
                    name: '雅昌拍卖首页',
                    path: '/'
                },
                {
                    name: '雅昌拍卖预展',
                    path: '/preauction'
                },
                {
                    name: '中国书画拍卖会',
                    path: '/'
                }
            ],
            detailData: {},
            jingpai: {},
            showTitle: '',
            tlNum: '',
            labelList: [],
            bigPicArray: [],
            PicWidth: [],
            PicHeight: [],
            speName: '',
            speId: '',
            attr: [],
            proPage: 1,
            proList: [],
            proFlag: false,
            extraInfo: [],
            extraInfoLabel: [],
            pcExtraInfo: [],
            otherPreList: [],
            indexList: [],
            newsList: [],
            sessionList: [],
            companyName: '',
            companyId: '',
            qrcodePic: '',
            organPreList: [],
            organResultList: [],
            loading: false,
            noMore: false,
            detailObj: {},
            status: 0,
            isLogin: 0,
            isHD: 0,
            orgCode: '',
            isLoading: true,
            sessionCode: '',
            scJSON: null,
            t: 0,
            flag: false,
            openProduct: false,
            leftArrClass: '',
            rightArrClass: '',

        }
    },
    asyncData({
        store,
        route
    }) {
        let params = {
            artCode: route.params.id.replace('/', ''),
            only_meta: 1
        }
        return store.dispatch("pageProDetail/getProDetail", [params, null, () => {}]);
    },
    computed: {
        ...mapGetters({
            getIsLoadIng: "pageProDetail/getIsLoadIng",
            getData: "pageProDetail/getData",
        }),
        disabled() {
            return this.loading || this.noMore
        },
        priceInfo() {
            let res = {
                label: '',
                price: ''
            }
            if (this.detailObj.BidSpecialStatus === 3 && this.detailObj.BidAuctionStatus === 3) {
                res = {
                    label: this.detailObj.price.label,
                    price: this.detailObj.price.text
                }
            } else {
                if (this.jingpai.auction_bid_status === 1) {
                    res = {
                        label: '起拍价',
                        price: this.jingpai.start_price_str
                    }
                } else if (this.jingpai.auction_bid_status === 2) {
                    if (this.jingpai.valid_price >= this.jingpai.start_price) {
                        res = {
                            label: '当前价',
                            price: this.jingpai.valid_price_str
                        }
                    } else {
                        res = {
                            label: '起拍价',
                            price: this.jingpai.start_price_str
                        }
                    }
                } else if (this.jingpai.auction_bid_status === 3) {
                    res = {
                        label: '当前价',
                        price: this.jingpai.transaction_price_str
                    }
                }
                if (this.jingpai.auction_status === 5) {
                    res.label = ''
                } else if (this.jingpai.auction_status === 1) {
                    res.label = '成交价'
                }
            }
            return res
        }
    },
    mounted() {
        this.t = Date.now()
       
        let parmas = {
            artCode: this.$route.params.id.replace('/', ''),
        }
        if (!this.getIsLoadIng) {
            this.getProDetail([parmas, null, () => {
                this.filteData();
            }])
        } else {
            this.filteData();
        }
        this.getMemType();

        // this.getProDetail();
        window.scroll({
            top: 0,
            left: 0
        })
        if (this.getCookie("_at_pt_0_")) {
            this.isLogin = 1
        }
    },
    methods: {
        ...mapActions({
            pageProDetail: "pageProDetail/getProDetail"
        }),
        getSurplusDate(endTime) {
            let beginTime = +new Date() / 1000
            endTime = Date.parse(endTime) / 1000
            if (endTime > beginTime) {
                let surplusTime = endTime - beginTime
                let hourNum = Math.floor(surplusTime / (1 * 60 * 60))
                let minuteNum = Math.floor((surplusTime % (1 * 60 * 60)) / 60)
                let secondNum = Math.floor(surplusTime % 60)

                hourNum = hourNum < 10 ? '0' + hourNum : hourNum.toString()
                minuteNum = minuteNum < 10 ? '0' + minuteNum : minuteNum.toString()
                secondNum = secondNum < 10 ? '0' + secondNum : secondNum.toString()

                return '时' + hourNum + '分' + minuteNum + '秒' + secondNum

            } else {
                return '已结束'
            }
        },
        timeStrText(e) {
            if (this.detailData.bid_type == 1 || this.detailData.bid_type == 2) {
                return this.jingpai.end_time_str || this.jingpai.start_time_str
            } else {
                return e
            }
        },
        timeStr() {
            if ((this.detailData.bid_type == 1 || this.detailData.bid_type == 2) && this.detailData.bid_status == 1 || this.detailData.bid_type == 1 && this.detailData.bid_status == 3) {
                return "开拍时间"
            }
            if (this.detailData.bid_type == 1 && this.detailData.bid_status == 2) {
                return "开拍时间"
            }
            if (this.detailData.bid_type == 2 && this.detailData.bid_status == 2) {
                return "距结拍"
            }
            if (this.detailData.bid_type == 2 && this.detailData.bid_status == 3) {
                return "结束时间"
            }
            return "拍卖时间"

        },
        gotoDownLoad() {
             window.location.href = 'https://artexpress.artron.net/download/tulu'
        },
        getBidListFun(auctionId, specialId) {
            getBidList({
                special_id: specialId,
                auction_id: auctionId,
                page_size: 2,
                page: 1
            }).then((res) => {
                if (res.code == 0) {
                    this.bidList = res.data.bid_list;
                    this.bidListTotal = res.data.total;
                }
            })
        },
        priceJudge() {
            for (let i in this.extraInfoLabel) {
                if (this.extraInfoLabel[i].type == 'gujia' && this.extraInfoLabel[i].text != '****') {
                    return true
                }
                if (this.extraInfoLabel[i].type == 'start_price' && this.extraInfoLabel[i].text != '****') {
                    return true
                }
                if (this.extraInfoLabel[i].type == 'now_price' && this.extraInfoLabel[i].text != '****') {
                    return true
                }
                if (this.extraInfoLabel[i].type == 'price' && (this.extraInfoLabel[i].text != '流拍' && this.extraInfoLabel[i].text != '撤拍' && this.extraInfoLabel[i].text != '未提供' && (this.isLogin && this.isMem == 1 || this.detailObj.BidSpecialStatus == 2))) {
                    return true
                }

            }
        },
        jumpLink(e) {
            window.location.href = e
        },
        gotoAPPFun() {
            if (this.detailData.bid_type == 1 && this.detailData.bid_status == 2 || this.detailData.bid_type == 2 && this.detailData.bid_status == 2 || (this.detailData.bid_type == 1 || this.detailData.bid_type == 2) && this.detailData.bid_status == 1) {
                this.dialogVisible = true;
            }

        },
        jumpLot(e) {
            if (this.proList.length) {

                for (let i in this.proList) {

                    if (this.$route.params.id == this.proList[i].ArtCode) {
                        if (e) {

                            if (Number(i) + 1 < this.proList.length) {

                                this.$router.push("/paimai-" + this.proList[Number(i) + 1].ArtCode + "?form=2");

                                break;
                            } else if (!this.noMore) {
                                this.getProListFun('', true)

                            }
                        } else {

                            if (Number(i) - 1 >= 0) {
                                this.$router.push("/paimai-" + this.proList[Number(i) - 1].ArtCode + "?form=2");
                                break;
                            }
                        }

                    }

                }
            }
        },
        openProductBox() {
            this.openProduct = !this.openProduct
        },

        leftArrow() {
            if (this.proList.length) {
                for (let i in this.proList) {

                    if (this.$route.params.id == this.proList[i].ArtCode && i == 0) {
                        this.leftArrClass = 'greyArrow'
                        break;
                    } else {
                        this.leftArrClass = 'greenArrow'
                        break;
                    }

                }
            }
        },
        rightArrow() {
            if (this.proList.length) {
                for (let i in this.proList) {
                    if (this.$route.params.id == this.proList[i].ArtCode) {
                        if (i == (Number(this.proList.length) - 1)) {
                            this.rightArrClass = 'greyArrow'
                            break;
                        } else {
                            this.rightArrClass = 'greenArrow'
                            break;
                        }

                    }

                }
            }
        },
        getMemType() {
            getMemType().then((res) => {
                if (res.code == 0) {
                    this.isMem = res.data.isMember
                }
            })
        },
        getAuctionInfoFun(id, special_id) {
            getAuctionInfo({
                special_id: special_id,
                auction_id: id,
                cloud_special_id: this.detailObj.CloudSpecialId,
            }).then((res) => {
                if (res.code == 0) {
                    this.jingpai = res.data.jingpai
                }
            })
        },
        mouseout() {
            this.proIdx = NaN
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        load() {
            this.loading = true
            this.getProListFun()
        },
        filteData() {
            let data = this.$store.state["pageProDetail"]["data"],
                that = this;
            this.contactData = data;
            
            this.isLoading = false
            if (!data.meta || !data.meta.title) {
                this.$message({
                    message: '该内容不存在～',
                    onClose() {
                        that.$router.push({
                            path: '/'
                        })
                    }
                });
                return false
            }
            this.detailData = data.live_info;
            this.showTitle = data.show_title
            this.tlNum = data.detail.tlNumber
            this.labelList = data.live_info && data.live_info.label_list ? data.live_info.label_list : []
            this.bigPicArray = data.detail.bigPicArray
            this.PicWidth = data.detail.PicWidth
            this.PicHeight = data.detail.PicHeight
            this.speId = data.special_code
            this.sessionCode = data.session_code
            this.attr = data.detail.attribute
            this.extraInfo = data.detail.extraInfo
            this.extraInfoLabel = data.extraInfo
            this.pcExtraInfo = data.pc_extra_info
            console.log("----------------------------")
            console.log(this.pcExtraInfo)
            this.isHD = data.detail.isHD
            this.detailObj = data.detail
            this.status = data.status
            this.crumbs[1].name = this.status == 5 ? '雅昌拍卖结果' : '雅昌拍卖预展'
            this.crumbs[1].path = this.status == 5 ? '/result' : '/preauction'
            this.crumbs[2].name = data.show_title
            this.crumbs[2].path = '/paimai-' + data.artCode
            let meetingId = ''
            let meetingName = ''
            this.attr.forEach(function (item) {
                if (item.type == 'special') {
                    that.speName = item.text
                }
                if (item.type == 'company') {
                    that.companyName = item.text
                    that.companyId = item.organCode
                }
                if (item.type == 'session') {
                    meetingName = item.text
                    meetingId = item.sessionCode
                }
            })
            let pcExtraInfo = data.pc_extra_info
            pcExtraInfo.forEach(function (item) {
                if (item.type == 'qrcode_pic') {
                    that.qrcodePic = item.text
                }
            })
            let spriceType = 0
            data.detail.extraInfo.forEach(function (i) {
                if (i.type == 'price') {
                    spriceType = i.smallText + i.text
                }
            })
            this.scJSON = {
                auction_items_id: this.id,
                auction_items_name: this.showTitle,
                the_auction_id: meetingId,
                the_auction_name: meetingName,
                auction_company: that.companyName,
                auction_specia_performance_id: this.speId,
                auction_specia_performance_name: that.speName,
                auction_lot_number: 'lot' + this.tlNum,
                auction_first: data.detail.classCodeOneName,
                auction_second: data.detail.classCodeTwoName,
                auction_state: this.status == 1 ? '待拍卖' : this.status == 2 ? '预展中' : this.status == 3 ? '待预展' : this.status == 4 ? '拍卖中' : this.status == 5 ? '已结拍' : '',
                auction_date: data.detail.picAttribute.auctionDate,
                is_price: spriceType
            }
           
            if((this.detailData.bid_type==1||this.detailData.bid_type==2)&&this.detailObj.BidShowTradePrice==1){
                this.getBidListFun(data.id, data.special_id);
            }
            sendScData('auctionDetailsPageScan', this.scJSON)
            this.getProListFun()
            this.getProSession()
            if (this.detailObj.CloudSpecialId) {
                this.getAuctionInfoFun(data.id, data.special_id)
            }

            this.$forceUpdate()
            let meta = data.meta;
            let head = document.getElementsByTagName('head');
            document.title = meta.title
            if (!document.querySelector('meta[name=description]')) {
                let meta2 = document.createElement('meta');
                meta2.name = 'description';
                meta2.content = meta.description || '';
                head[0].appendChild(meta2)
            } else {
                document.querySelector('meta[name=description]').setAttribute('content', meta.description || '')
            }
            this.getProReco();
        },
        getProDetail() {
            let param = {
                artCode: this.id
            }
            getProDetail(param).then((res) => {
                this.isLoading = false
                let dataJSON = res.data,
                    that = this;
                this.detailData = dataJSON.live_info;
                this.showTitle = dataJSON.show_title
                this.tlNum = dataJSON.detail.tlNumber
                this.labelList = dataJSON.live_info.label_list ? dataJSON.live_info.label_list : []
                this.bigPicArray = dataJSON.detail.bigPicArray
                this.PicWidth = dataJSON.detail.PicWidth
                this.PicHeight = dataJSON.detail.PicHeight
                this.extraInfoLabel = dataJSON.extraInfo
                let meetingId = ''
                let meetingName = ''
                this.detailObj = dataJSON.detail
                this.speId = dataJSON.special_code
                this.sessionCode = dataJSON.session_code
                this.isHD = dataJSON.detail.isHD
                this.attr = dataJSON.detail.attribute
                this.extraInfo = dataJSON.detail.extraInfo
                this.status = dataJSON.status
                this.crumbs[1].name = this.status == 5 ? '雅昌拍卖结果' : '雅昌拍卖预展'
                this.crumbs[1].path = this.status == 5 ? '/result' : '/preauction'
                this.crumbs[2].name = dataJSON.show_title
                this.crumbs[2].path = '/paimai-' + dataJSON.artCode

                this.attr.forEach(function (item) {
                    if (item.type == 'special') {
                        that.speName = item.text
                    }
                    if (item.type == 'company') {
                        that.companyName = item.text
                        that.companyId = item.organCode
                    }
                    if (item.type == 'session') {
                        meetingName = item.text
                        meetingId = item.sessionCode
                    }
                })
                let pcExtraInfo = dataJSON.pc_extra_info
                this.pcExtraInfo = pcExtraInfo

                pcExtraInfo.forEach(function (item) {
                    if (item.type == 'qrcode_pic') {
                        that.qrcodePic = item.text
                    }
                })
                this.$forceUpdate()
                let spriceType = 0
                dataJSON.detail.extraInfo.forEach(function (i) {
                    if (i.type == 'price') {
                        if (i.text != '') {
                            spriceType = i.smallText + i.text
                        }
                    }
                })
                //4预展中 5结拍 1待预展
                this.scJSON = {
                    auction_items_id: this.id,
                    auction_items_name: this.showTitle,
                    the_auction_id: meetingId,
                    the_auction_name: meetingName,
                    auction_company: that.companyName,
                    auction_specia_performance_id: this.speId,
                    auction_specia_performance_name: that.speName,
                    auction_lot_number: 'lot' + this.tlNum,
                    auction_first: dataJSON.detail.classCodeOneName,
                    auction_second: dataJSON.detail.classCodeTwoName,
                    auction_state: this.status == 1 ? '待拍卖' : this.status == 2 ? '预展中' : this.status == 3 ? '待预展' : this.status == 4 ? '拍卖中' : this.status == 5 ? '已结拍' : '',
                    auction_date: dataJSON.detail.picAttribute.auctionDate,
                    is_price: spriceType
                }

                sendScData('auctionDetailsPageScan', this.scJSON)
                if (this.detailObj.CloudSpecialId) {
                    this.getAuctionInfoFun(dataJSON.id, dataJSON.special_id)
                }

                this.getProListFun()
                this.getProSession()
                if((this.detailData.bid_type==1||this.detailData.bid_type==2)&&this.detailObj.BidShowTradePrice==1){
                    this.getBidListFun(dataJSON.id, dataJSON.special_id);
                }
                
            });
        },
        gotoLogin() {
            if (this.$route.query.from) {
                return false
            }
            window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
        },
        formatPrice(num) {
            var arr = (num + '').split('.');
            var intSum = arr[0].replace(/\B(?=(?:\d{3})+$)/g, ','); //取到整数部分
            var fen = arr[1] ? '.' + arr[1] : ''
            var ret = intSum + fen;
            return ret;
        },
        formatPriceTologin(num) {
            // if (num == 0) {
            //     return "****"
            // }
            // let str = (num + '').substring(0, 1);
            // return str + '***';
            return "****"
        },
        getProListFun(val, jumpFlag) {
            if (!this.speId) {
                return false
            }
            let param = {
                specialCode: this.speId,
                showType: 0,
                limit: 10,
                ord: 2,
                pageId: this.proPage,
                keyword: val
            }
            let that = this;
            getProList(param).then((res) => {
                if (res.code == 0) {
                    let dataJSON = res.data.list
                    if (dataJSON.length > 0) {
                        this.proPage++
                        this.noMore = false
                    } else {
                        this.noMore = true
                    }
                    this.loading = false
                    dataJSON.forEach(function (item) {
                        that.proList.push(item)
                    })
                    for (let i = 0; i < this.proList.length; i++) {
                        // console.log(this.proList[i].TlNumber + "---" + this.tlNum)
                        if (this.proList[i].ArtCode == this.id) {
                            this.flag = true;
                            this.proIdx = i
                            break
                        }
                    }
                    // alert(dataJSON)
                    // alert(this.proIdx)
                    if (!this.flag && dataJSON.length > 0 && parseInt(this.proList[this.proList.length - 1].TlNumber) < parseInt(this.tlNum.replace(/[^0-9]/g, ""))) {
                        this.getProListFun()
                    } else if (!isNaN(this.proIdx)) {
                        this.scrollPro(this.proIdx)
                    }
                    this.$forceUpdate()
                    $('.productListBox dl').hover(function () {
                        $(this).addClass('hover')
                    }, function () {
                        $(this).removeClass('hover')
                    })
                    this.leftArrow()
                    this.rightArrow()
                    // let msgFalg = false
                    // if (this.proList.length) {
                    //     for (let i in this.proList) {
                    //         if (this.$route.params.id == this.proList[i].ArtCode) {
                    //             msgFalg = true;
                    //         }

                    //     }
                    // }
                    // if (!msgFalg) {
                    //     this.getProListFun()
                    // }
                    if (jumpFlag) {
                        this.jumpLot(jumpFlag)
                    }
                }

            });
        },
        scrollPro(i) {
            setTimeout(() => {
                document.querySelector('.productListBox').scrollTop = 140 * i
            }, 100)
        },
        getProReco() {
            let parmas = {
                art_code: this.id
            }
            getProReco(parmas).then((res) => {
                this.otherPreList = res.data.other_pre_list
                this.indexList = res.data.index_list
                this.newsList = res.data.news_list
                this.organResultList = res.data.organ_result_list
                this.organPreList = res.data.organ_pre_list
            });
        },
        formatMoney(number) {
            let decimals = 0,
                decPoint = '.',
                thousandsSep = ','
            number = (number + '').replace(/[^0-9+-Ee.]/g, '')
            let n = !isFinite(+number) ? 0 : +number
            let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            let s = ''
            let toFixedFix = function (n, prec) {
                let k = Math.pow(10, prec)
                return '' + Math.ceil(n * k) / k
            }
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
            let re = /(-?\d+)(\d{3})/
            while (re.test(s[0])) {
                s[0] = s[0].replace(re, '$1' + sep + '$2')
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        },
        gotoSo() {
            this.proList = [];
            this.proPage = 1
            this.getProListFun(this.input2)
        },
        getProSession() {
            console.log(this.sessionCode)
            let parmas = {
                session_code: this.sessionCode,
            }
            getProSession(parmas).then((res) => {
                this.sessionList = res.data.list
            })
        }
    },
    components: {
        copyright,
        Header,
        topNav,
        columnNav,
        Crumbs,
        anchorBox,
        SessionList,
        ProductInfo,
        ProductRight,
        Mark,
        ProductHeader,
        EmptyPage,
        watermark,
        AdvLamu,
        AdvImage,
        contact
    }
}
</script>

<style lang="scss">
.AdGroupBox {
    background: rgba(0, 0, 0, 0);
    box-shadow: unset;
    width: fit-content;

    .mt20 {
        border-radius: 15px;
        overflow: hidden;
    }

    .el-dialog__body {
        padding: 0;

        img {
            width: 100%;
        }
    }

    .el-dialog__header {
        position: absolute;
        color: #fff;
        padding: 0;
        right: -50px;
        top: -50px;

        .el-dialog__headerbtn .el-dialog__close {
            color: #fff;
            background: rgba(0, 0, 0, 0.3);
            padding: 6px;
            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.5);
        }
    }
}
</style>
<style lang="scss" scoped>
@import url("../../assets/css/reset.css");

.crumbs {
    background: #F9FCF8;
}

//@import url("../../assets/css/share.scss");
.w880 {
    width: 880px;
}

.w280 {
    width: 280px;
}

.bidListBox {
    width: 100%;
    margin-top: 60px;

    .bidListMsg {
        width: 100%;

        .bidBox {
            width: 100%;
            margin-top: 10px;

            .bidTime {
                float: right;
                font-weight: 400;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
            }

            .bidName {
                margin-right: 12px;
                font-weight: 400;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
            }

            .bidLabelBox {
                margin-right: 12px;
                padding: 2px 8px;
                color: #C3C3C3;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid rgba(0, 0, 0, 0.1);
            }

            .bidLead {
                color: #50AB37;
                border: 1px solid rgba(50, 157, 21, 0.3);
            }

            span {
                display: inline-block;
            }
        }

    }

    .bidListTitle {
        width: 100%;

        .bidtotal {
            font-weight: 400;
            font-size: 14px;
            color: #8C8C8C;
        }

        .allBidBtn {
            float: right;
            font-weight: 400;
            font-size: 14px;
            color: #8C8C8C;
            cursor: pointer;
        }

        .bidTitle {
            font-weight: 600;
            font-size: 16px;
            color: #000000;
            padding: 0 15px;
            position: relative;

            &::after {
                content: "";
                width: 4px;
                height: 100%;
                background: #329D15;
                position: absolute;
                left: 0;
                top: 0;

            }
        }

        span {
            display: inline-block;
        }
    }

}

.lotChangeBox {
    float: inline-end;
    margin-top: 5px;

    .lotText {
        font-weight: 600;
        padding: 4px 7px;
        border-radius: 5px;
        font-size: 14px;
        color: #000000;
        display: inline-block;
        cursor: pointer;

        &:hover {
            color: #28920B !important;
            background: #F3F3F3 !important;
        }
    }

    .greyArrow {
        cursor: pointer;
        font-size: 12px;
        padding: 6px 7px;
        color: #B8B8B8;
        background: rgba(0, 0, 0, 0.04);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid rgba(0, 0, 0, 0.04);
    }

    .greenArrow {
        cursor: pointer;
        font-size: 12px;
        color: #fff;
        padding: 6px 7px;
        background: #329D15;
        border-radius: 4px 4px 4px 4px;
    }
}

.pw {}

.productBanner {
    display: flex;
    background: #F9FCF8;
    padding-bottom: 65px;

    .productMsgBox {
        padding-left: 24px;
        width: calc(100% - 500px);
        // background: url('../../assets/imgs/detail_bg1.png') no-repeat;
        // background-size: 480px 433px;
        box-sizing: border-box;
        position: relative;

        .artronIcon {
            position: absolute;
            background: url('../../assets/imgs/detail_bg2.png') no-repeat;
            background-size: 193px 48px;
            width: 193px;
            height: 48px;
            right: 20px;
            bottom: -40px;
        }

        .proTitle {
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            line-height: 28px;
            text-align: justified;
            font-style: normal;
            text-transform: none;
        }

        .liveBtn {
            width: 100%;
            font-weight: 600;
            font-size: 16px;
            line-height: 48px;
            color: #FFFFFF;
            text-align: center;
            background: #329D15;
            border-radius: 8px 8px 8px 8px;
            cursor: pointer;
            margin-top: 15px;
        }

        .proInfo {
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            margin-top: 24px;
            padding-top: 24px;

            .infoRow {
                margin-bottom: 12px;

                .infoLabel {
                    display: inline-block;
                    width: 100px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #8C8C8C;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                }

                .infoText {
                    display: inline-block;
                    font-weight: 600;
                    font-size: 14px;
                    color: #000000;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    .max-commission {
                        height: 17px;
                        line-height: 17px;
                        display: inline-block;
                        background: url("../../assets/imgs/Union@2x.png") no-repeat;
                        background-size: 100% 100%;
                        font-weight: 600;
                        font-size: 11px;
                        vertical-align: text-top;
                        margin-left: 5px;
                        padding-left: 5px;
                        color: #ffffff;
                    }
                }

            }

        }

        .proPriceBox {
            .priceMsg {
                margin-bottom: 20px;
                margin-right: 40px;

                .priceLabel {
                    font-weight: 400;
                    font-size: 14px;
                    color: #8C8C8C;
                    margin-bottom: 7px;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                }

                .priceText {
                    font-weight: bold;
                    font-size: 18px;
                    color: #000000;
                    line-height: 21px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;

                    span {
                        font-weight: 400;
                        font-size: 12px;
                        color: #000000;
                        line-height: 14px;
                    }

                    .greenTip {
                        margin-left: 10px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 500;
                        font-size: 13px;
                        color: #329D15;
                    }
                }

            }

        }

        .productFlag {
            margin-top: 12px;
            margin-bottom:12px;
            display: flex;
            justify-content: space-between;
            position: relative;
            align-items: center;

            .flag {
                font-size: 0;

                span {
                    display: inline-block;
                    color: #000;
                    font-size: 12px;
                    padding: 0 4px;
                    line-height: 18px;
                    border: 1px solid #BFBFBF;
                    border-radius: 4px;
                    margin-right: 10px;
                }
            }

            .shareBox {
                color: #BFBFBF;
                display: flex;
            }
        }
    }

    .productList {
        background-color: #fff;
        padding-top: 20px;
        float: inline-end;
        width: 380px;
        box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
        border-radius: 16px 16px 16px 16px;

        h3 {
            padding: 20px;
            line-height: 28px;
            font-size: 20px;
            font-weight: bold;
        }

        .proSearch {
            padding: 0 20px 14px;
            display: flex;
            justify-content: space-between;

            /deep/.el-input {
                width: 260px;
                background-color: #fff;
                border: 1px solid #D9D9D9;
                border-radius: 4px;
                position: relative;

                .el-input__icon {
                    line-height: 30px;
                }

                .el-input__prefix {
                    left: inherit;
                    right: 5px;
                }
            }

            /deep/.el-input-group__append {
                padding: 0 5px;
                background-color: transparent;
                border: 0;

                .el-button {
                    border: 0;
                    background-color: transparent;
                    padding: 0;
                }
            }

            /deep/.el-input__inner {
                border: 0;
                height: 30px;
                line-height: 30px;
                padding: 0 10px;
                width: 230px;
            }

            /deep/.el-input__inner:focus {
                border-color: #329D15;
            }

            .allBtn {
                display: block;
                margin-left: 10px;
                width: 70px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                color: #fff;
                border-radius: 4px;
                background-color: #329D15;
            }
        }

        .productListBox {
            height: 520px;
            position: relative;
            overflow-x: hidden;
            overflow-y: auto;

            dl {
                padding: 20px;
                display: flex;
                justify-content: space-between;

                &:hover {
                    background-color: #f5f5f5;
                }
            }

            .curr {
                background-color: #f5f5f5;
            }

            .hover {
                background-color: #e7e7e7;
            }

            dt {
                width: 100px;
                height: 100px;
                position: relative;

                .bigFlag {
                    position: absolute;
                    background: url("../../assets/imgs/icon_list_HDpic_26@2x.png") no-repeat;
                    background-size: 100% 100%;
                    width: 35px;
                    height: 20px;
                    right: 0;
                    top: 0;
                }

                .imgBox {
                    background-color: #fff;
                }
            }

            dd {
                height: 100px;
                width: 220px;
                padding-left: 8px;
            }

            h4 {
                line-height: 24px;
                font-size: 16px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-bottom: 8px;
            }

            p {
                line-height: 20px;
                font-size: 12px;
                margin-bottom: 4px;
                color: #595959;
            }

            .sessimg-red {
                color: #f5222d;
            }

            p:last-child {
                margin-bottom: 0;
            }
        }

        /deep/.ps__rail-y.ps--clicking .ps__thumb-y,
        .ps__rail-y:focus>.ps__thumb-y,
        .ps__rail-y:hover>.ps__thumb-y {
            background-color: #BFBFBF;
        }
    }
}
</style>
